import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  height: 100%;

  padding-top: 88px;

  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.greys.lighter};
`;

export const Content = styled.div`
  flex: 1;
  width: 100%;

  padding: 24px;

  display: flex;
  flex-direction: column;
  align-items: center;

  overflow-y: auto;
`;

export const ContentInner = styled.div`
  width: 80%;
  max-width: 1600px;

  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;

export const TopSection = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  column-gap: 24px;
`;

export const MetricsRow = styled.div`
  display: flex;
  align-items: stretch;
  column-gap: 16px;
`;

export const MainGrid = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  column-gap: 24px;
  align-items: stretch;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;

export const Footer = styled.div`
  height: 64px;
  min-height: 64px;
  width: 100%;
  padding: 0 24px;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 24px;

  background-color: ${({ theme }) => theme.colors.greys.lightest};
  border-top: 1px solid ${({ theme }) => theme.colors.greys.light};
`;
